import { render, staticRenderFns } from "./PopHorario.vue?vue&type=template&id=60785e2a&scoped=true"
import script from "./PopHorario.vue?vue&type=script&lang=js"
export * from "./PopHorario.vue?vue&type=script&lang=js"
import style0 from "./PopHorario.vue?vue&type=style&index=0&id=60785e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60785e2a",
  null
  
)

export default component.exports